function getPointCoordinates(
  centerX: number,
  centerY: number,
  radius: number,
  angleInDegrees: number,
) {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
}

export function describeArc(
  x: number,
  y: number,
  radius: number,
  width: number,
  startAngle: number,
  endAngle: number,
): string {
  const start = getPointCoordinates(x, y, radius, endAngle);
  const end = getPointCoordinates(x, y, radius, startAngle);
  const radius2 = radius + width;
  const start2 = getPointCoordinates(x, y, radius2, endAngle);
  const end2 = getPointCoordinates(x, y, radius2, startAngle);

  const arcSweep = endAngle - startAngle <= 180 ? '0' : '1';
  return [
    'M',
    start.x,
    start.y,
    'A',
    radius,
    radius,
    0,
    arcSweep,
    0,
    end.x,
    end.y,
    'A',
    width,
    width,
    0,
    0,
    0,
    end2.x,
    end2.y,
    'A',
    radius2,
    radius2,
    0,
    arcSweep,
    1,
    start2.x,
    start2.y,
    'A',
    width,
    width,
    0,
    0,
    1,
    start.x,
    start.y,
  ].join(' ');
}
